<template lang="pug">
  .login-page.login-section
    .login-box
      .pad
        Logo
        div.locked-login(v-if="is_locked == true") 
          center
            br
            p
              strong Portal locked, please enter the set password.
            br
            p If you haven’t been given the link to this portal by Positive People HR, please contact us on 
              a(href="tel:01484444760") 01484 444760 
              | or 
              a(href="mailto:info@positivepeoplehr.co.uk") info@positivepeoplehr.co.uk
              |  so that we can talk you through details of the service.
          form(@submit="lockedLogin")
            .input-group.group-password
              label {{ $t("fields.password") }}
              input(type="password" v-model="locked_password" :placeholder="$t('pages.login.password_placeholder')")
            .input-group.group-button
              input.login-button(name="submit" type="submit" :value="$t('pages.login.unlock')")
        form(@submit="login" v-else)
          .input-group.group-username
            label {{ $t("fields.username") }}
            input(type="text" v-model="username" :placeholder="$t('pages.login.username_placeholder')")
          .input-group.group-password
            label {{ $t("fields.password") }}
            input(type="password" v-model="password" :placeholder="$t('pages.login.password_placeholder')")
          .input-group.group-button
            input.login-button(name="submit" type="submit" :value="$t('pages.login.button')")
            .error-message(v-if="error") {{ error }}
          .input-group.links
            router-link(to="/forgot") {{ $t("pages.login.forgot") }}
            router-link(to="/register") {{ $t("pages.login.register") }}
          loading(:active.sync="loading")
</template>

<script>
  import Logo from "@/components/navigation/Logo.vue";
  import Locale from "@/components/Locale.vue";

  import AuthService from '@/services/auth.js'

  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';

  export default {
    data () {
      return {
        loading: false,
        error: '',
        is_locked: true,
        locked_password: '',
        username: '',
        password: ''
      }
    },
    mounted: function() {
      this.checkSiteLocked();
    },
    methods: {
      validateForm() {
        const VALIDATE_MESSAGES = this.$i18n.t('pages.login.validate_messages');

        const MSG_USERNAME_AND_PASSWORD = VALIDATE_MESSAGES.enter_username_and_password;
        const MSG_USERNAME = VALIDATE_MESSAGES.enter_username;
        const MSG_PASSWORD = VALIDATE_MESSAGES.enter_password;

        if(this.username.length < 2 && this.password.length < 2) {
          this.error = MSG_USERNAME_AND_PASSWORD;
          return false;
        }

        if(!this.username || this.username.length < 2) {
          this.error = MSG_USERNAME;
          return false;
        }

        if(!this.password || this.password.length < 2) {
          this.error = MSG_PASSWORD;
          return false;
        }

        return true;
      },
      async checkSiteLocked() {
        let item = this;
        try {
          const response = await AuthService.is_site_locked();
          if(response.data === false)
            return item.is_locked = false;
        } catch(err) {
          console.log('error')
        }
      },
      async lockedLogin() {
        event.preventDefault();
        try {
          const response = await AuthService.locked_login({
            password: this.locked_password
          });
          const response_data = response.data;
          if(response_data === false)
            return this.$swal.fire({
              title: 'Invalid',
              text: 'Invalid unlock details',
              type: 'error'
            })

          if(response_data === true)
            return this.is_locked = false;
        } catch(err) {
          console.log('error')
        }
      },
      async login(event) {
        const ERROR_MESSAGES = this.$i18n.t('pages.login.error_messages');

        // console.log('// Login method')
        event.preventDefault();

        if(this.validateForm() == false)
          return false;

        try {
          this.loading = true;
          const response = await AuthService.login({
            username: this.username,
            password: this.password
          })

          if(response) {
            // we're setting the user and token.. saving to store..
            this.$store.dispatch('setUser', response.data.user)
            this.$store.dispatch('setToken', response.data.token)

            this.$router.push({
              name: 'dashboard'
            })
          } else {
            this.loading = false;
          }
          
        } catch(error) {
          this.loading = false;

          if(error == 'Error: Network Error') {
            if(navigator.onLine) {
              // console.log(error);
              return this.error = ERROR_MESSAGES.server_error;  
            } else {
              return this.error = ERROR_MESSAGES.internet_connection;
            }
          }

          // simple error handling..
          if(error.response.status == 403)
            return this.error = ERROR_MESSAGES[error.response.data];

          if(error.response.status == 429)
            return this.error = ERROR_MESSAGES.too_many_attempts;

          return this.error = 'Could not login, Status: ' + error.response.status;
        }
      }
    },
    components: {
      Logo,
      Locale,
      Loading
    }
  }
</script>

<style lang="scss">
  .login-page.login-section {
    background-image:url('~@/assets/background-login.jpg');
    background-repeat:no-repeat;
    background-size:cover;
    width:100%;
    min-height:100vh;
    position: relative;
    padding-top:45px;
    .error-message {
      line-height:20px;
      margin:8px 0px;
      background:#eee;
      padding:15px;
      font-size:13px;
    }
    .login-box {
      background-color: #fefefe;
      // border: 4px solid #999;
      width: 90%;
      max-width: 400px;
      margin: 0px auto;
      padding: 40px 0px;
      .pad {
        .logo-container {
          text-align:center;
          margin-top:25px;
        }
        .input-group {
          max-width:320px;
          margin:0px auto;
          margin-top: 8px;
          &.group-username {
            margin-top:20px;
          }
          &.group-button {
            margin-bottom:18px;
          }
          &.links {
            a {
              font-weight:bold;
              text-decoration: none;
              font-size:14px;
              line-height:29px;
            }
          }
          display:flex;
          flex-direction:column;
          label,input {
            font-size:15px;
            width:100%;
            margin-top:8px;
            color: $gradient-7;
            font-weight:600;
          }
          .login-button {
            background: $primary;
            font-size:14px;
            line-height:56px;
            cursor:pointer;
            transition: background 200ms ease;
            &:hover {
              background: $primary-dark;
            }
          }
          input {
            font-weight:initial;
            border:0px none;
            background: $gradient-3;
            color: $gradient-7;
            line-height:45px;
            text-indent:16px;
            ::placeholder,
            :-ms-input-placeholder,
            ::-webkit-input-placeholder {
              color: $gradient-7;
              opacity:1;
            }
            &[type="submit"] {
              color:#fefefe;
              font-size:12px;
            }
          }
        }
        padding: 0px 15px;
      }
    }
  }
</style>